const isEnableMock = process.env.REACT_APP_ENABLE_MOCK

const mock = async () => {
  if (isEnableMock) {
    await import('./mock/localStorage')
    const { worker } = await import('./mock/fetch/msw')
    worker.start()
  }
}

export { mock }
